import apiClient from "./api";
import { getApiAccessToken } from "./UserService";

const baseUrl = "/api/ContractCrews";

export interface ContractCrewContractOption {
  id: number;
  name: string;
}

export interface ContractCrewItem {
  id: number;
  name: string;
  description?: string | null;
  isInUse: boolean;
}

export interface ContractCrewsResponse {
  availableContracts: ContractCrewContractOption[];
  selectedContractId?: number | null;
  crews: ContractCrewItem[];
}

export interface UpsertContractCrewRequest {
  name: string;
  description?: string | null;
}

async function authHeader(): Promise<Record<string, string>> {
  const token = await getApiAccessToken();
  return { Authorization: `Bearer ${token}` };
}

export const getContractCrews = async (
  addressSystemId: number,
  contractId?: number | null,
): Promise<ContractCrewsResponse> => {
  const headers = await authHeader();
  const response = await apiClient.get<ContractCrewsResponse>(
    `${baseUrl}/${addressSystemId}`,
    {
      headers,
      params: contractId ? { contractId } : undefined,
    },
  );
  return response.data;
};

export const createContractCrew = async (
  addressSystemId: number,
  contractId: number,
  request: UpsertContractCrewRequest,
): Promise<number> => {
  const headers = await authHeader();
  const response = await apiClient.post<{ id: number }>(
    `${baseUrl}/${addressSystemId}/contracts/${contractId}/crews`,
    request,
    { headers },
  );
  return response.data.id;
};

export const updateContractCrew = async (
  addressSystemId: number,
  contractId: number,
  crewId: number,
  request: UpsertContractCrewRequest,
): Promise<void> => {
  const headers = await authHeader();
  await apiClient.put(
    `${baseUrl}/${addressSystemId}/contracts/${contractId}/crews/${crewId}`,
    request,
    { headers },
  );
};

export const deleteContractCrew = async (
  addressSystemId: number,
  contractId: number,
  crewId: number,
): Promise<void> => {
  const headers = await authHeader();
  await apiClient.delete(
    `${baseUrl}/${addressSystemId}/contracts/${contractId}/crews/${crewId}`,
    { headers },
  );
};
